import { action, mutator } from 'satcheljs';
import type { EnterpriseOrPremiumLicenseStatus } from '../store/schema/enterpriseOrPremiumLicenseStore';
import { getStore } from '../store/store';

export interface UpdateEnterpriseOrPremiumLicenseStatusActionMessage {
    enterpriseOrPremiumLicenseStatus: EnterpriseOrPremiumLicenseStatus;
}
export const updateEnterpriseOrPremiumLicenseStatus: (
    enterpriseOrPremiumLicenseStatus: EnterpriseOrPremiumLicenseStatus
) => UpdateEnterpriseOrPremiumLicenseStatusActionMessage = action(
    'updateEnterpriseOrPremiumLicenseStatus',
    (
        enterpriseOrPremiumLicenseStatus: EnterpriseOrPremiumLicenseStatus
    ): UpdateEnterpriseOrPremiumLicenseStatusActionMessage => ({
        enterpriseOrPremiumLicenseStatus,
    })
);

export const updateEnterpriseOrPremiumLicenseStatusMutator: (
    actionMessage: UpdateEnterpriseOrPremiumLicenseStatusActionMessage
) => void = mutator(
    updateEnterpriseOrPremiumLicenseStatus,
    ({ enterpriseOrPremiumLicenseStatus }) => {
        getStore().enterpriseOrPremiumLicenseStatus = enterpriseOrPremiumLicenseStatus;
    }
);
